export default "__VITE_ASSET__BQiMSZYI__"